import { render, staticRenderFns } from "./OidcLogout.vue?vue&type=template&id=18f7434a&"
import script from "./OidcLogout.vue?vue&type=script&lang=ts&"
export * from "./OidcLogout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src567975772/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f7434a')) {
      api.createRecord('18f7434a', component.options)
    } else {
      api.reload('18f7434a', component.options)
    }
    module.hot.accept("./OidcLogout.vue?vue&type=template&id=18f7434a&", function () {
      api.rerender('18f7434a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/authentication/OIDC/OidcLogout.vue"
export default component.exports